export {ReportCodeEmbedBaseService as ReportCodeEmbedService} from '../../webapp-common/shared/services/report-code-embed-base.service';

